export default {
  //server : "http://localhost:8529", // local
  server : "https://slapps.fr",
  dbUrl : "/athena/_db/production/apollo",
  usersUrl : "/athena/_db/production/athena",
  usersDbUrl : "/athena/_db/production/athena",
}
